import React from 'react';
import {
  Platform,
  TouchableOpacity,
  StyleSheet,
  View,
  Text,
  StyleProp,
  ViewStyle,
} from 'react-native';

import Icon, { IconName } from 'shared/modules/common/components/atoms/Icon';
import colors from 'shared/modules/common/constants/colors';
import typography from 'shared/modules/common/constants/typography';
import generateID from 'shared/modules/common/utils/generate-id';
import { formatToCurrency } from 'shared/utils/japanese';

type ListItemProps = {
  iconName: IconName;
  title: string;
  subtitle?: string | null;
  divisiontitle?: string | null;
  date?: string;
  amount: number;
  description?: string | null | JSX.Element;
  onPress: () => void;
  titleTestID?: TestProps;
  subtitleTestID?: TestProps;
  dateTestID?: TestProps;
  amountTestID?: TestProps;
  descriptionTestID?: TestProps;
  alignMiddle?: boolean;
  style?: StyleProp<ViewStyle>;
  id?: string;
};

const ListItem = (props: ListItemProps & TestProps) => (
  <TouchableOpacity
    style={[
      styles.container,
      props.alignMiddle && styles.alignCenter,
      props.style,
    ]}
    onPress={props.onPress}
    // testID={props.testID}
    // accessible={props.accessible}
    /** Generate HTML and Test IDs  */
    {...generateID(props.id)}
    /** Platform-specific props */
    {...Platform.select({
      web: {
        accessibilityRole: 'button',
      },
    })}
  >
    <Icon name={props.iconName} size="24" style={styles.icon} />

    <View style={styles.middle}>
      <Text
        style={typography.caption01}
        numberOfLines={3}
        // {...props.titleTestID}
      >
        {props.title}
      </Text>
      {!!props.subtitle && (
        <Text
          style={styles.subText}
          // {...props.subtitleTestID}
        >
          {props.subtitle}
        </Text>
      )}
      {!!props.divisiontitle && (
        <Text style={styles.subText}>{props.divisiontitle}</Text>
      )}
      {!!props.date && (
        <Text style={styles.subText} {...props.dateTestID}>
          {props.date}
        </Text>
      )}
    </View>

    <View style={styles.right}>
      <Text style={typography.caption01} {...props.amountTestID}>
        {formatToCurrency(props.amount)}
      </Text>
      {!!props.description && (
        <Text style={styles.subText} {...props.descriptionTestID}>
          {props.description}
        </Text>
      )}
    </View>
  </TouchableOpacity>
);

export default ListItem;

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    flexWrap: 'nowrap',
    alignItems: 'center',
    margin: 16,
  },
  alignCenter: {
    alignItems: 'center',
  },
  icon: {
    marginRight: 16,
    alignSelf: 'center',
  },
  middle: {
    flex: 1,
  },
  right: {
    alignItems: 'flex-end',
  },
  subText: {
    ...typography.caption02,
    color: colors.grey,
    marginTop: 8,
  },
});
